import { Box } from '@mui/material';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { m } from 'framer-motion';

import { ForbiddenIllustration } from 'src/assets/illustrations';
import { MotionContainer, varBounce } from 'src/components/animate';
import Page from 'src/components/page/page';
import { RouterLink } from 'src/routes/components';

export default function Forbidden() {
  return (
    <Page title="Sem permissão">
      <Box px={2} py={8}>
        <MotionContainer>
          <m.div variants={varBounce().in}>
            <Typography textAlign="center" variant="h3" sx={{ mb: 2 }}>
              Sem permissão
            </Typography>
          </m.div>
          <m.div variants={varBounce().in}>
            <Typography textAlign="center" sx={{ color: 'text.secondary' }}>
              A página que você está tentando acessar possui acesso restrito.
              <br />
              Por favor, consulte o administrador do sistema.
            </Typography>
          </m.div>
          <m.div variants={varBounce().in}>
            <ForbiddenIllustration sx={{ height: 260, my: { xs: 5, sm: 10 } }} />
          </m.div>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Button component={RouterLink} href="/" size="large" variant="contained">
              Ir para a página inicial
            </Button>
          </Box>
        </MotionContainer>
      </Box>
    </Page>
  );
}
